import { createStyles, makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $headerCard': {
      color: TextColors.light,

      '& $superHeading': {
        color: SecondaryColors.main,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $headerCard': {
      color: TextColors.dark,

      '& $superHeading': {
        color: SecondaryColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) =>
    createStyles({
      root: {
        minHeight: '35px',

        '&.dark-theme': darkTheme.root,
        '&.light-theme': lightTheme.root,
      },
      headerCard: {
        marginBottom: muiTheme.spacing(3),
      },
      superHeading: {
        '&.MuiTypography-root': {
          marginBottom: muiTheme.spacing(1),
        },
      },
      title: {},
      ctaWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: muiTheme.spacing(6),
      },
      contentCards: {
        '& .column': {
          display: 'flex',
        },
        '& .MuiCard-root': {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        '& .MuiCard-root > .MuiCardContent-root': {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        },
      },
    }),
  { name: 'GenFeaturedContentGrid' },
);

export default useStyles;
